import { useCallback, useMemo, useState } from 'react';
import {
  useAppDispatch,
  useAppSelector,
} from 'v2/resources/hooks/useAppSelector';
import { IOption } from '../types';
import { useHistory } from 'react-router-dom';
import { useGetCyclesCodes } from 'v2/resources/hooks/services/cycles/useCycles';
import { setSelectedCycle } from 'redux/selectedCycle';
import { IResponseCyclesCode } from 'v2/resources/types/cycles';
import { CyclesServices } from 'v2/resources/services/cycles';
import { useProperties } from 'v2/resources/hooks/services/properties/useProperties';
import { IIconName } from 'v2/resources/types/icon';
import { PropertiesServices } from 'v2/resources/services/proporties';
import { setNameProperty } from 'redux/nameProperty';
import { userPermissionsDomainAction } from 'redux/userPermissionsDomain/actions';
import { IOptionMenuSide } from 'v2/resources/types/optionsMenuSide';
import useSelectOptionMenuSide from 'v2/resources/hooks/useSelectOptionMenuSide';
import { useWindowSizes } from 'v2/resources/hooks/useWindowSizes';
import { logout } from 'v2/resources/helpers/logout';

const useHeader = () => {
  const dispatch = useAppDispatch();
  const navigate = useHistory();
  const NAME_FARM = localStorage.getItem('idProperty');

  const { nameUser } = useAppSelector((state) => state.nameUser);
  const { selectedCycle } = useAppSelector((state) => state.selectedCycle);
  const { nameProperty } = useAppSelector((state) => state.nameProperty);

  const { valueSelectedMenuSide } = useSelectOptionMenuSide();
  const { isMobile, isTablet } = useWindowSizes();

  const [openProfile, setOpenProfile] = useState(false);
  const [openCyclesCodes, setOpenCyclesCodes] = useState(false);
  const [openFarm, setOpenFarm] = useState(false);
  const [showModalCreateNewCycle, setShowModalCreateNewCycle] = useState(false);
  const [openItems, setOpenItems] = useState<number[]>([]);
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const {
    data: cyclesCodes,
    isLoading: isLoadingCyclesCodes,
    refetch: refetchCyclesCodes,
  } = useGetCyclesCodes(nameProperty);

  const { data: properties, isLoading: isLoadingProperties } = useProperties();

  const handleOpenChangeCyclesCodes = () => {
    setOpenCyclesCodes((prevState) => !prevState);
  };
  const handleOpenChangeProfile = () => {
    setOpenProfile((prevState) => !prevState);
  };
  const handleOpenChangeFarm = () => {
    setOpenFarm((prevState) => !prevState);
  };
  const handleShowModalCreateNewCycle = () => {
    setShowModalCreateNewCycle((prevState) => !prevState);
  };
  const handleIsMenuVisible = () => {
    setIsMenuVisible((prevState) => !prevState);
  };

  const getNameCycle = useMemo(() => {
    if (!selectedCycle) return 'Sem Ciclo';

    if (selectedCycle && selectedCycle?.code) {
      if (selectedCycle.code.includes('Ciclo')) {
        return selectedCycle.code as string;
      }
      return `Ciclo ${selectedCycle.code}`;
    }

    return `Ciclo ${selectedCycle.cod}`;
  }, [selectedCycle]);
  const nameCycle = getNameCycle.split('(')[0].trim();

  const handleNavigate = useCallback(
    (route: string) => {
      if (isMenuVisible) setIsMenuVisible(false);
      navigate.push(route);
    },
    [isMenuVisible, navigate]
  );

  const handleNavigateAndChangeProfile = (route: string) => {
    handleNavigate(route);
    handleOpenChangeProfile();
  };

  const handleLogout = () => {
    navigate.replace('/logout');
  };

  const handleDispacthCycleCode = (cycleCode: IResponseCyclesCode) => {
    dispatch(setSelectedCycle(cycleCode));
    handleOpenChangeCyclesCodes();
  };

  const createNewCycle = async (specie_category: string) => {
    try {
      const response = await CyclesServices.postCycleCodes({
        specie_category,
      });

      if (response) {
        await refetchCyclesCodes();
      }
    } catch (error) {
    } finally {
      handleShowModalCreateNewCycle();
    }
  };

  const handleChooseProperty = async (id: string | number, name: string) => {
    try {
      const response = await PropertiesServices.chooseProperties({
        id,
        name,
      });

      if (nameProperty !== name) {
        dispatch(setSelectedCycle(null));
      }
      dispatch(setNameProperty(name));
      dispatch(userPermissionsDomainAction(response.domain_permissions));

      if (cyclesCodes && cyclesCodes.length > 0) {
        dispatch(setSelectedCycle(cyclesCodes[cyclesCodes.length - 1]));
      }
    } catch (error) {
    } finally {
      handleOpenChangeFarm();
    }
  };

  const toggleItem = (id: number) => {
    setOpenItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const itemsProfileData: Array<IOption> = [
    {
      id: 1,
      title: 'Minha conta',
      onClick: () => handleNavigateAndChangeProfile('editUser'),
      iconName: 'AccountCircleOutlined',
    },
    {
      id: 2,
      title: 'Fazenda',
      onClick: () => handleNavigateAndChangeProfile(`property/${NAME_FARM}`),
      iconName: 'FactoryOutlined',
    },
    {
      id: 3,
      title: 'Sair',
      onClick: () => handleLogout(),
      iconName: 'LogoutOutlined',
    },
  ];

  const itemsCyclesCode = () => {
    const defaultItemCycleCode: IOption = {
      id: 0,
      title: 'Criar Ciclo',
      onClick: () => handleShowModalCreateNewCycle(),
      iconName: 'AddOutlined',
    };

    if (isLoadingCyclesCodes || !cyclesCodes) {
      return [defaultItemCycleCode];
    }

    return [
      ...cyclesCodes!.map((cycle) => ({
        id: cycle?.id,
        title: `Ciclo ${cycle?.cod}`,
        onClick: () => handleDispacthCycleCode(cycle),
        iconName: cycle.specie_category as 'Camarão' | 'Peixe',
      })),
      defaultItemCycleCode,
    ];
  };

  const itemsFarm = () => {
    const defaultItemFarm: IOption = {
      id: 1,
      title: 'Criar fazenda',
      onClick: () => handleNavigate('/first-property'),
      iconName: 'AddOutlined',
    };

    if (isLoadingProperties || !properties || properties.length === 0) {
      return [defaultItemFarm];
    }

    return [
      ...properties!.map((item) => ({
        id: Number(item?.id),
        title: item.name,
        onClick: () => handleChooseProperty(item.id, item.name),
        iconName: 'GiteOutlined' as IIconName,
      })),
    ];
  };
  const nameFarm = properties?.length === 0 ? 'Sem fazenda' : nameProperty;

  const handleSelectedOptions = (
    optionsFather: string[],
    optionsChildren: string[]
  ) => {
    return optionsFather.some((valueFather) =>
      optionsChildren.includes(valueFather)
    );
  };

  const fnValues = (option: IOptionMenuSide[]) => {
    return option.map((item) => item.values).flat();
  };

  //CONSTANTS
  const childrenReports: Array<IOptionMenuSide> = [
    {
      id: 1,
      title: 'Relatório de consumo',
      values: ['report-input'],
      onClick: () => handleNavigate('/report-input'),
    },
    {
      id: 2,
      title: 'Relatório de produção',
      values: ['report-production'],
      onClick: () => handleNavigate('/report-production'),
    },
    {
      id: 3,
      title: 'Relatório financeiro',
      values: ['report-finance'],
      onClick: () => handleNavigate('/report-finance'),
    },
  ];

  const childrenFarm: Array<IOptionMenuSide> = [
    {
      id: 1,
      title: 'Viveiros físicos',
      values: ['ponds', 'pond', 'pondId'],
      onClick: () => handleNavigate('/ponds'),
    },
    {
      id: 2,
      title: 'Insumos',
      values: ['supplies', 'supply', 'suppliesId'],
      onClick: () => handleNavigate('/supplies'),
    },
  ];

  const childrenMetrics: Array<IOptionMenuSide> = [
    {
      id: 1,
      title: 'Análise de água',
      values: ['measurements', 'measurement', 'measurementsId'],
      onClick: () => handleNavigate('/measurements'),
    },
    {
      id: 2,
      title: 'Biometria',
      values: ['biomeasures', 'biomeasure', 'biomeasuresId'],
      onClick: () => handleNavigate('/biomeasures'),
    },
    {
      id: 3,
      title: 'Análise de sáude',
      values: ['analysis', 'analyse', 'analyseId'],
      onClick: () => handleNavigate('/analysis'),
    },
  ];

  const childrenCultivation: Array<IOptionMenuSide> = [
    {
      id: 1,
      title: 'Viveiros por ciclo',
      values: ['cycles', 'cycle', 'cyclesId'],
      onClick: () => handleNavigate('/cycles'),
    },
    {
      id: 2,
      title: 'Povoamentos',
      values: ['populations', 'population', 'populationsId'],
      onClick: () => handleNavigate('/populations'),
    },
    {
      id: 3,
      title: 'Transferências',
      values: ['transfers', 'transfer', 'transfersId'],
      onClick: () => handleNavigate('/transfers'),
    },
    {
      id: 4,
      title: 'Consumo',
      values: ['inputs', 'input', 'inputsId'],
      onClick: () => handleNavigate('/inputs'),
    },
    {
      id: 51,
      title: 'Medições',
      values: fnValues(childrenMetrics),
      onClick: () => {},
      children: childrenMetrics,
    },
    {
      id: 6,
      title: 'Mortalidade',
      values: ['mortalities', 'mortality', 'mortalitiesId'],
      onClick: () => handleNavigate('/mortalities'),
    },
    {
      id: 7,
      title: 'Despesca',
      values: ['harvests', 'harvest', 'harvestId'],
      onClick: () => handleNavigate('/harvests'),
    },
  ];

  const childrenSettings: Array<IOptionMenuSide> = [
    {
      id: 1,
      title: 'Parâmetros',
      values: ['parameters', 'parameter', 'parametersId'],
      onClick: () => handleNavigate('/parameters'),
    },
    {
      id: 2,
      title: 'Medidas',
      values: ['unities', 'unit', 'unityId', 'customUnit'],
      onClick: () => handleNavigate('/unities'),
    },
    {
      id: 3,
      title: 'Formulários',
      values: ['forms', 'form', 'formsId'],
      onClick: () => handleNavigate('/forms'),
    },
  ];

  const childrenManagement: Array<IOptionMenuSide> = [
    {
      id: 1,
      title: 'Estoque',
      values: ['stocks', 'stock', 'stocksId'],
      onClick: () => handleNavigate('/stocks'),
    },
    {
      id: 2,
      title: 'Remessa',
      values: ['lots', 'lot', 'lotsId'],
      onClick: () => handleNavigate('/lots'),
    },
  ];
  const childrenProduction: Array<IOptionMenuSide> = [
    {
      id: 1,
      title: 'Fazenda',
      values: fnValues(childrenFarm),
      onClick: () => {},
      children: childrenFarm,
    },
    {
      id: 2,
      title: `Cultivo | ${nameCycle}`,
      values: fnValues(childrenCultivation),
      onClick: () => {},
      children: childrenCultivation,
    },
    {
      id: 3,
      title: 'Gerenciamento',
      values: fnValues(childrenManagement),
      onClick: () => {},
      children: childrenManagement,
    },
    {
      id: 4,
      title: 'Configurações',
      values: fnValues(childrenSettings),
      onClick: () => {},
      children: childrenSettings,
    },
  ];

  const childrenShopping: Array<IOptionMenuSide> = [
    {
      id: 1,
      title: 'Fornecedores',
      values: ['providers', 'provider', 'providersId'],
      onClick: () => handleNavigate('/providers'),
    },
    {
      id: 1,
      title: 'Listar compras',
      values: ['purchases', 'purchase', 'purchasesId'],
      onClick: () => handleNavigate('/purchases'),
    },
  ];

  const childreControlAccount: Array<IOptionMenuSide> = [
    {
      id: 1,
      title: 'Minhas contas',
      values: ['bankAccounts', 'bankAccount', 'bankAccountId'],
      onClick: () => handleNavigate('/bank-accounts'),
    },
    {
      id: 2,
      title: 'Transações',
      values: ['transactions', 'transaction', 'transactionId'],
      onClick: () => handleNavigate('/transactions'),
    },
  ];

  const childrenFinancial: Array<IOptionMenuSide> = [
    {
      id: 1,
      title: 'Centro de custos',
      values: ['accountsCenter', 'accountCenter', 'accountCenterId'],
      onClick: () => handleNavigate('/accounts-center'),
    },
    {
      id: 2,
      title: 'Pagamentos',
      values: ['payBills', 'payBill', 'payBillsId'],
      onClick: () => handleNavigate('/pay-bills'),
    },
    {
      id: 3,
      title: 'Recebimentos',
      values: ['receiveBills', 'receiveBill', 'receiveBillId'],
      onClick: () => handleNavigate('/receive-bills'),
    },
    {
      id: 4,
      title: 'Controle de contas',
      values: fnValues(childreControlAccount),
      onClick: () => {},
      children: childreControlAccount,
    },
  ];

  const childreCommercial: Array<IOptionMenuSide> = [
    {
      id: 1,
      title: 'Compras',
      values: ['clients', 'client', 'clientId'],
      onClick: () => handleNavigate('/clients'),
      children: childrenShopping,
    },
    {
      id: 2,
      title: 'Vendas',
      values: ['sales', 'sale', 'saleId'],
      onClick: () => handleNavigate('/sales'),
    },
  ];

  const childreEmployees: Array<IOptionMenuSide> = [
    {
      id: 1,
      title: 'Usuários',
      values: ['users', 'user', 'userId'],
      onClick: () => handleNavigate('/users'),
    },
  ];

  const optionsMenuSide: Array<IOptionMenuSide> = [
    {
      id: 1,
      title: 'Início',
      values: ['home'],
      onClick: () => handleNavigate('/'),
      iconName: 'HomeOutlined',
    },
    {
      id: 2,
      title: 'Greenfy A.I',
      values: [
        'ai',
        'settings-ai',
        'add-files-ai',
        'list-files-ai',
        'edit-files-ai',
      ],
      onClick: () => handleNavigate('/greenfy-ai'),
      iconName: 'AutoAwesomeOutlined',
    },
    {
      id: 3,
      title: 'Desempenho',
      values: ['dashboard'],
      onClick: () => handleNavigate('/dashboard'),
      iconName: 'InsertChartOutlined',
    },
    {
      id: 4,
      title: 'Relatórios',
      values: fnValues(childrenReports),
      onClick: () => {},
      iconName: 'ContentPasteSearchOutlined',
      children: childrenReports,
    },
    {
      id: 5,
      title: 'Produção',
      values: fnValues(childrenProduction),
      onClick: () => {},
      iconName: 'SolarPowerOutlined',
      children: childrenProduction,
    },
    {
      id: 6,
      title: 'Compras',
      values: fnValues(childrenShopping),
      onClick: () => {},
      iconName: 'StorefrontOutlined',
      children: childrenShopping,
    },
    {
      id: 7,
      title: 'Financeiro',
      values: fnValues(childrenFinancial),
      onClick: () => {},
      iconName: 'CurrencyExchangeOutlined',
      children: childrenFinancial,
    },
    {
      id: 8,
      title: 'Comercial',
      values: fnValues(childreCommercial),
      onClick: () => {},
      iconName: 'CardTravelOutlined',
      children: childreCommercial,
    },
    {
      id: 9,
      title: 'Funcionários',
      values: fnValues(childreEmployees),
      onClick: () => {},
      iconName: 'PeopleAltOutlined',
      children: childreEmployees,
    },
    {
      id: 10,
      title: 'Ajuda',
      values: ['instructions'],
      onClick: () => handleNavigate('/instructions'),
      iconName: 'HelpOutlineOutlined',
    },
  ];

  const paddingHeader = isMobile ? '20px' : '25px 50px';
  return {
    nameUser,
    itemsProfileData,
    itemsCyclesCode: itemsCyclesCode(),
    itemsFarm: itemsFarm(),
    nameCycle,
    nameProperty: nameFarm,
    openProfile,
    openCyclesCodes,
    openFarm,
    showModalCreateNewCycle,
    optionsMenuSide,
    valueSelectedMenuSide,
    openItems,
    isMobile,
    isTablet,
    paddingHeader,
    isMenuVisible,

    toggleItem,
    handleOpenChangeCyclesCodes,
    handleOpenChangeProfile,
    handleOpenChangeFarm,
    handleShowModalCreateNewCycle,
    createNewCycle,
    handleNavigate,
    handleSelectedOptions,
    handleIsMenuVisible,
  };
};
export default useHeader;
